import { IsArray, IsBoolean, IsNumber, IsOptional } from 'class-validator';
import { TransformBoolean } from '../../custom-validation';

export class BillingProductSearchDto {
  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  merchantIdList?: number[];

  @IsOptional()
  @TransformBoolean()
  @IsBoolean()
  active?: boolean;
}